import React, { useRef, useState, useEffect, Children } from 'react';

function useElementSize(element) {
    const [elementSize, setElementSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setElementSize({
                width: element.current ? element.current.offsetWidth : 0,
                height: element.current ? element.current.offsetHeight : 0
            });
        }

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return elementSize;
}

function BallsBackground({ children }) {

    const ball1 = useRef();
    let ball1Size = useElementSize(ball1);

    const ball2 = useRef();
    let ball2Size = useElementSize(ball2);

    const ball3 = useRef();
    let ball3Size = useElementSize(ball3);
    return (
        <div className="background">
            <div className="cover-background"></div>
            <div className="ball-container">
                <div className="ball ball1" ref={ball1} style={{ height: ball1Size.width }}></div>
                <div className="ball ball2" ref={ball2} style={{ height: ball2Size.width }}></div>
                <div className="ball ball3" ref={ball3} style={{ height: ball3Size.width }}></div>
            </div>
            {children}
        </div>
    )
}

export default BallsBackground